import type { IconData } from '@stacksjs/iconify-core'

export const subtraction: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 0a7 7 0 1 1-3 13.326A7 7 0 1 1 10 .673A7 7 0 0 1 13 0M7 2a5 5 0 1 0 1.002 9.9A6.97 6.97 0 0 1 6 7c0-1.907.763-3.637 2-4.9A5 5 0 0 0 7 2m6 0a5 5 0 1 0 0 10a5 5 0 0 0 0-10\"/>",
  "width": 20,
  "height": 14,
  "viewBox": "0 0 20 14"
}

export default subtraction
